import * as React from 'react';
import TableCell from '@mui/material/TableCell';
import { Link } from '@mui/material';

export interface LinkCellProps {
  align?: 'left' | 'center' | 'right' | 'inherit' | 'justify' | undefined;
  text?: string;
  onClick?: Function;
  color?: 'error' | 'warning';
}

export const LinkCell = ({
  align = 'left',
  text,
  onClick,
  color,
}: LinkCellProps) => {
  return (
    <Link
      component={'button'}
      variant="body1"
      color={'secondary'}
      onClick={() => onClick && onClick()}
      align={align}
    >
      {text}
    </Link>
  );
};
